import axios from 'axios'
import qs from 'qs'

export default {

  getTransactions(params) {
    return axios.get('/reports/admin/transactions', {
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    })
  }

}